var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mdAndDown)?_c('v-app-bar',{attrs:{"dark":"","color":"primary","app":"","height":"56px"}},[(!_vm.disableMenu)?_c('AppBarMenu'):_vm._e(),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }